import React from 'react';
import { config } from '_helpers';
import styles from './layoff.module.scss';

const fallback = () => `${config.apiUrl}/${config.altImg}`;

const Avatar = ({ photo, name }) => (
  <img
    className={styles.avatar}
    alt=''
    aria-hidden='true'
    title={name}
    src={photo ? `${config.apiUrl}/${photo}` : fallback()}
    onError={(event) => {
      if (event.target.src !== fallback()) {
        event.target.src = fallback();
      }
    }}
  />
);

export default Avatar;
